export const API_DOMAIN = 'controllershiphub.finergy.amazon.dev';
export const AWS_REGION = 'us-east-1';

/**
 * Enum for Control IDs.
 * @enum {string}
 */
export enum ControlId {
  GRC5253 = 'grc5253',
}
